<template>
 <el-main id="brand" :style = 'styleChange'>
        <div id="logo"><img src="../assets/logo_wetouch_english.png"/></div>
        <div class="slogan">
            <p>我们是企业数字化与互联<b>创新教练</b></p>
            <p>用<b>“陪伴式服务”</b>将最专业的的数字创新基因注入到您的企业中</p>
        </div>
    </el-main>
</template>

<script>
export default {
    name:'BrandInfo',

    data(){
        return {
            styleChange:{
                height:"",
                }
            }
        },
    mounted(){
        const that = this;
        that.styleChange.height = window.innerHeight*.85+'px';
        console.log("高度：",that.styleChange.height);
        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#brand{
    display:flex;
    flex-direction:column;
    justify-content: center;
    background:linear-gradient(rgba(255,255,255,0.7),rgba(255,255,255,0.8)),url('../assets/talk2.jpg') no-repeat;
    background-size: cover;
    background-position:top;

}

#brand .slogan{
      padding: 0 20px;
      text-align: center;
      line-height: 2rem;
      margin:2px;
  }
  #brand div{
      margin-bottom:5px;
      margin-top:170px;
  }

#logo img{
    height:100px;
}
</style>
